(() => {
  const el = document.getElementById('fmf-judgeme-defer') || document.currentScript;
  const SETTINGS_SRC = (el && el.getAttribute('data-settings-src')) || (window.fmfJdgmSettingsSrc || '');
  const CDN = (window.jdgm && window.jdgm.CDN_BASE_URL) ||
    'https://cdn.shopify.com/extensions/01a17dcc-1695-71d5-a93a-09446c7e037f/judgeme-829/assets/';
  let loading = null;
  let loaded = false;

  function loadScript(src, attrs) {
    return new Promise((resolve, reject) => {
      if ([...document.scripts].some(s => s.src === src || s.getAttribute('data-fmf-jdgm-src') === src)) {
        resolve(); return;
      }
      const s = document.createElement('script');
      s.setAttribute('data-fmf-jdgm-src', src);
      s.async = true;
      s.src = src;
      if (attrs) Object.keys(attrs).forEach(k => s.setAttribute(k, attrs[k]));
      s.onload = () => resolve();
      s.onerror = () => { s.remove(); reject(new Error('failed ' + src)); };
      document.head.appendChild(s);
    });
  }

  async function loadJudgeMe() {
    if (loaded) return;
    if (loading) return loading;
    loading = (async () => {
      if (!SETTINGS_SRC) throw new Error('Judge.me settings src missing');
      await loadScript(SETTINGS_SRC, { 'data-cfasync': 'false' });
      const base = (window.jdgm && window.jdgm.CDN_BASE_URL) || CDN;
      await loadScript(base + 'loader.js', { 'data-cfasync': 'false' });
      loaded = true;
      document.documentElement.setAttribute('data-fmf-judgeme', 'loaded');
      window.dispatchEvent(new CustomEvent('fmf:judgeme-loaded'));
    })().catch(err => {
      loading = null;
      console.warn('[fmf] Judge.me defer load failed', err);
      throw err;
    });
    return loading;
  }

  window.fmfLoadJudgeMe = loadJudgeMe;

  function arm() {
    loadJudgeMe().catch(() => {});
  }

  ['pointerdown', 'keydown', 'touchstart'].forEach(ev => {
    window.addEventListener(ev, arm, { once: true, passive: true });
  });

  function observe() {
    const targets = [
      ...document.querySelectorAll('[data-fmf-review-lazy], #judgeme_product_reviews, .fmf-deferred-review-widget')
    ];
    if ('IntersectionObserver' in window && targets.length) {
      const io = new IntersectionObserver(entries => {
        if (entries.some(e => e.isIntersecting)) {
          io.disconnect();
          arm();
        }
      }, { rootMargin: '200px 0px' });
      targets.forEach(t => io.observe(t));
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observe);
  else observe();

  setTimeout(arm, 12000);

  if (/#judgeme/.test(location.hash) || /judgeme_(token|review_uuid|dynamic_form|follow_up_token|upload_pictures|pre_verified)/.test(location.search)) {
    arm();
  }
})();
